import AbstractService from "./AbstractService";

export default class RegionSearchService extends AbstractService {
	static searchPlaces(queryParams, getCancelToken) {
		return this.get({
			baseURL: "https://region-search.rollkall.com/api",
			endpoint: "/places",
			queryParams,
			getCancelToken,
		});
	}
}
